
import { EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, ViewChild, inject, ChangeDetectorRef } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { FlightService } from 'src/app/services/flight.service';
import { InsuranceService } from 'src/app/services/insurance.service';


import { DataService } from 'src/app/services/data.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { SettingsService } from '../../../services/settings.service';
import { ColorsService } from 'src/app/services/colors.service';
import * as XLSX from "xlsx";
import * as ExcelJS from 'exceljs';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/util/dialog/dialog.service';

import { DatePipe } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialogConfig } from '@angular/material/dialog';
import { UserprofileService } from 'src/app/services/userprofile.service';
import { Pipe, PipeTransform } from '@angular/core';
import { AirConfigService } from 'src/app/services/air-config.service'
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { MatTabGroup } from '@angular/material/tabs';
import jwt_decode from 'jwt-decode';
import { TripService } from 'src/app/services/trip.service'
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { BusService } from 'src/app/services/bus.service';
interface Seat {
  name: string;
  row: number;
  column: number;
  baseFare: number;
  fare: number;
  serviceTaxAbsolute: number;
  available: boolean;
  ladiesSeat: boolean;
  malesSeat: boolean;
  window: boolean;
  doubleBirth: boolean;
  markupFareAbsolute: number;
}
@Component({
  selector: 'app-bus-list',
  templateUrl: './bus-list.component.html',
  styleUrls: ['./bus-list.component.css']
})
export class BusListComponent implements OnInit {

    showSidebar: boolean = false
    pointerEvents:boolean=false
  
  
    username: any
    color: any
    parentType: any
    countdown: number = 600;
  interval: any;
  messageData: any;
  userUuid: any
  userType: any

    constructor(private BusService:BusService,private DialogService:DialogService,private UserService: UserService, private TripService: TripService, private UserprofileService: UserprofileService, private SettingsService: SettingsService, private toastMsgService: ToastmsgService, private fb: FormBuilder, private FlightService: FlightService,private InsuranceService:InsuranceService, private route: ActivatedRoute
      , private router: Router, private data: DataService, private AirConfigService: AirConfigService, private userInfoService: UserInfoService, private cdr: ChangeDetectorRef, private ColorsService: ColorsService) {
      
      let ite: string = userInfoService.getParentUser() || ''
      if (ite) {
        let token: any = jwt_decode(ite)
        if (token) {
          this.parentType = token?.type
  
  
        }
      }
  
      this.username = userInfoService.getUsername();
      this.ColorsService.colors("", "").then((color: any) => {
        this.color = color
      })
        .catch((error: any) => {
        });
      this.userType = this.userInfoService.getUserType()
      this.userType = this.userType.toUpperCase()
  
      this.userUuid = this.userInfoService.getUserUuid()
  
      // console.log(this.userUuid)
  
 
      this.route.queryParams.subscribe(params => {
        let data: any
        data = params
  
      });
      this.data.portMessage.subscribe((message: any) => this.messageData = message)
  
      this.data.deliverMsg(this.messageData)
  
    
  
      if (this.messageData === "default message") {
        this.router.navigate(["/app/bus"]);
        

      } else {
       
        
        this.showPending=true
        this.searchBus()

        // setTimeout(() => {
        //   this.showPending=false
        //   // this.searchData()

        // }, 3000);
      }
  
     
    }
  
   
   
  
  
   
    showPending:boolean=false
    blankList:boolean=false
    visibleflights:any=[]
    insuranceDataList:any=[]
    insurancePlansList:any=[]

    displayedColumns: any[] = [];
  columnsDisplay=this.displayedColumns
  columnHeaderMap: { [key: string]: string } = {};

    searchBus() {
       this.blankList=false
  
  this.insuranceDataList=[]
      setTimeout(() => {
        this.showPending = false
  
      }, 20 * 60 * 1000);
   
      this.showPending = true
     
      let request = JSON.parse(JSON.stringify(this.messageData))
      delete request.uuid;
      console.log(request)
     let requests:any={
      "requestId": request.requestId,
      "source": request.from.cityLabel,
      "sourceId": request.from.id,
      "destination": request.to.cityLabel,
      "destinationId":request.to.id,
      "dateOfJourney": request.tripStartDate
    }
      this.BusService.search(requests)
        .subscribe({
          next: (res) => {
            this.showPending = false

            let dataa: any
            dataa = res
            let data:any=dataa?.busSearchResponse
            if(data){
              console.log(data)
              if(data.length!=0){
              this.buss=data
            }


            }


  
  
         
  
          }, error: (err) => {
            this.blankList=true
  
            this.showPending = false
  
            //this.router.navigate(["/app/flight"]);
            // this.toastMsgService.setMsg({ msg: "Sorry, there are no matching results ", msgTitle: "Warning", msgType: "W" });
  
          }
        }
        )
    }
  
    

//   getSumInsuredByPlanType(element: any, col: string): number | string {
//     const planType = this.columnHeaderMap[col];
//     console.log('3')

//     if (!element?.plans || !planType || !element?.name) return '-';
// console.log(planType)
//     const matchingPlan = element.plans.find(
//       (plan: any) => plan.planType === planType 
//     );

// let matchData:any='-'
//       console.log(matchingPlan)

//     if (!('coverageValue' in matchingPlan)) {
//       console.log('1')
//       // The key doesn't exist
//       matchData='matchingPlan.plans'
//     }else{
//       console.log('3')

//       matchData= matchingPlan?.coverageValue ?? '-'
//     }
    
//     return matchData;
//     // totalPremium
//     // totalPremiumAmount
//   }
getSumInsuredByPlanType(element: any, col: string): number | string {
  const planType = this.columnHeaderMap[col];
  // console.log('Plan Type:', planType);
// console.log(planType)
  if (!element?.plans || !planType) {
    // console.log('Missing required data (plans, planType, or name)');
    return '-';
  }

  const matchingPlan = element?.plans?.find((plan: any) => plan.planType === planType);
  // console.log('Matching Plan:', matchingPlan);

//   if (!matchingPlan || !('coverageValue' in matchingPlan)) {
//     console.log('coverageValue not found in matching plan');
//     let output = '';
// let total = 0;
//     matchingPlan.persons.forEach((p:any, index:any) => {
//       output += `Person ${index + 1}: ${matchingPlan.totalPremiumAmount} | `;
//       total += p.totalPremium;
//     });
    
//     output += `Total Sum = ${total.toFixed(2)}`;
//     return output;
//   }
if (!matchingPlan || !('coverageValue' in matchingPlan)) {
  // console.log('coverageValue not found in matching plan');

  let headerRow = '';
  let valueRow = '';
  let total = 0;

  matchingPlan.persons.forEach((p: any, index: number) => {
    if( matchingPlan.persons.length!=1){

    headerRow += `<th>Person&nbsp;${index + 1}</th>`;}
    valueRow += `<td>${p.totalPremium?.toFixed()}</td>`;
    total = matchingPlan.totalPremiumAmount?.toFixed();
  });
  // console.log(matchingPlan.persons.length)
if( matchingPlan.persons.length!=1){
  headerRow += `<th><strong>Total</strong></th>`;
  valueRow += `<td><strong>${total}</strong></td>`;

  
const style = document.createElement('style');
style.innerHTML = `
  
table th, table td {
  border: 2px solid #E0D2D1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 8px;
  text-align: start;
}

table th {
  background-color: #DDEAF6;
  border-collapse:separate
}

table tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}

`;
document.head.appendChild(style);
}
  const tableHTML = `
    <table class="custom-table">
      <tr style="font-weight: bold; border: 1px solid #ccc;">
        ${headerRow}
      </tr>
      <tr style="border: 1px solid #ccc;">
        ${valueRow}
      </tr>
    </table>
  `;

  return tableHTML;

}


  const matchData = matchingPlan.coverageValue ?? '-';
  // console.log('Coverage Value:', matchData);

  return matchData;
}
stickyColumns = [0, 1, 7, 8];

stickyColumn = [0, 1,2, 7, 8];





generateBookingInsurance(item:any){
  console.log(this.insurancePlansList)
let element:any=  this.insurancePlansList.filter((items:any)=>items.planType===item)
console.log(element)
if(element.length!=0){
  element=element[0]

}
  // console.log(item)
  let request:any={
      "channel": "WEB",
      "insuranceRequest": this.messageData,
       "planName":element.planName,
       "insurancePlanSearchResponse":element
  }
  this.InsuranceService.generateBookingInsurance(request)
  .subscribe({
    next : (res) => {
      if(res) {
        let data: any
        data = res?.body
        if(data){
        let url = "/app/insurance-book?id=" + this.SettingsService.transform(data?.orderNumber)
        window.open(url); 
        }else{
          this.toastMsgService.setMsg({ msg: "Unable to book; please try later !", msgTitle: "Warning", msgType: "W" });

        }
              
      } else {
        this.toastMsgService.setMsg({ msg: "Unable to book; please try later !", msgTitle: "Warning", msgType: "W" });
      } 

    },error : (err) => {
      this.toastMsgService.setMsg({ msg: "Unable to book; please try later !", msgTitle: "Warning", msgType: "W" });

    }
  }
)
}



buses:any = [
  {
    name: 'Hans Travels (I) Private Limited',
    type: 'A/C Sleeper (2+1)',
    departureTime: '19:30',
    departureDate: '12 JUL',
    duration: '36h 35m',
    arrivalTime: '08:05',
    arrivalDate: '14 JUL+1 day',
    rating: 3.7,
    reviews: 31,
    price: 2800,
    seatsLeft: 24,
    singleSeats: 8,
    showSeats:false,
    seats:{
      decks: [
        {
          seats: [
            { number: 'C', available: false, imageId: 'SLEEPER_UNAVAILABLE_MALE_false', id: 'd0_r1_c0' },
            { number: 'F', available: false, imageId: 'SLEEPER_UNAVAILABLE_MALE_false', id: 'd0_r1_c1' },
            { number: '6', available: true, imageId: 'SLEEPER_AVAILABLE_UNISEX_false', id: 'd0_r3_c0' },
            { number: '5', available: true, imageId: 'SLEEPER_AVAILABLE_UNISEX_false', id: 'd0_r3_c1' },
          ]
        },
        {
          seats: [
            { number: '21', available: true, imageId: 'SLEEPER_AVAILABLE_UNISEX_false', id: 'd1_r9_c3' },
            { number: '19', available: true, imageId: 'SLEEPER_AVAILABLE_UNISEX_false', id: 'd1_r9_c0' },
          ]
        }
      ],
      images: [
        {
          imageId: 'SLEEPER_UNAVAILABLE_MALE_false',
          unselectedUrl: 'https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seatmap/seat_sl_uav_mal.webp'
        },
        {
          imageId: 'SLEEPER_AVAILABLE_UNISEX_false',
          unselectedUrl: 'https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seatmap/seat_sl_avl_uni.webp'
        }
      ],
     
    },
    dropPoints:[
      { time: '05:50, 14 JUL', name: 'Thane', detail: 'bus will change at indore with 10 hour layover' },
      { time: '06:00, 14 JUL', name: 'Vikhroli', detail: 'bus will change at indore with 10 hour layover' },
      { time: '06:05, 14 JUL', name: 'Chembur', detail: 'bus will change at indore with 10 hour layover' },
      { time: '06:40, 14 JUL', name: 'Sion', detail: 'bus will change at indore with 10 hour layover' },
      { time: '07:05, 14 JUL', name: 'Vile Parle East', detail: 'bus will change at indore with 10 hour layover' }
    ],
    seatConfig: [
      {
        seat_price: 250,
        seat_map: [
          {
            seat_label: "1",
            layout: "g_____"
          },
          {
            seat_label: "2",
            layout: "gg__gg"
          },
          {
            seat_label: "3",
            layout: "gg__gg"
          },
          {
            seat_label: "4",
            layout: "gg__gg"
          },
          {
            seat_label: "5",
            layout: "gg__gg"
          },
          {
            seat_label: "6",
            layout: "gg__gg"
          },
          {
            seat_label: "7",
            layout: "gg__gg"
          },
          {
            seat_label: "8",
            layout: "gggggg"
          }
        ]
      }
    ]
  },
  {
    name: 'Hans Travels (I) Private Limited',
    type: 'A/C Sleeper (2+1)',
    departureTime: '20:25',
    departureDate: '12 JUL',
    duration: '35h 10m',
    arrivalTime: '07:35',
    arrivalDate: '14 JUL+1 day',
    rating: 3.2,
    reviews: 28,
    price: 2800,
    seatsLeft: 24,
    singleSeats: 8,
    showSeats:false,
    seats:{
      "decks": [
        {
            "seats": [
                {
                    "number": "C",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 0,
                    "col": 0,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_false",
                    "id": "d0_r1_c0"
                },
                {
                    "number": "F",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 0,
                    "col": 1,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_false",
                    "id": "d0_r1_c1"
                },
                {
                    "number": "6",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 2,
                    "col": 0,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d0_r3_c0"
                },
                {
                    "number": "5",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 2,
                    "col": 1,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d0_r3_c1"
                },
                {
                    "number": "E",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 0,
                    "col": 3,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_false",
                    "id": "d0_r1_c3"
                },
                {
                    "number": "12",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 4,
                    "col": 0,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d0_r5_c0"
                },
                {
                    "number": "11",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 4,
                    "col": 1,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d0_r5_c1"
                },
                {
                    "number": "4",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 2,
                    "col": 3,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d0_r3_c3"
                },
                {
                    "number": "18",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 6,
                    "col": 0,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_false",
                    "id": "d0_r7_c0"
                },
                {
                    "number": "17",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 6,
                    "col": 1,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_false",
                    "id": "d0_r7_c1"
                },
                {
                    "number": "10",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 4,
                    "col": 3,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d0_r5_c3"
                },
                {
                    "number": "24",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 8,
                    "col": 0,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d0_r9_c0"
                },
                {
                    "number": "23",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 8,
                    "col": 1,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d0_r9_c1"
                },
                {
                    "number": "16",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 6,
                    "col": 3,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_false",
                    "id": "d0_r7_c3"
                },
                {
                    "number": "22",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 8,
                    "col": 3,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d0_r9_c3"
                },
                {
                    "number": "32",
                    "seatType": "VERTICAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 12,
                    "col": 1,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_true",
                    "id": "d0_r12_c2"
                },
                {
                    "number": "28",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 10,
                    "col": 3,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d0_r11_c3"
                },
                {
                    "number": "30",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 10,
                    "col": 0,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d0_r11_c0"
                },
                {
                    "number": "29",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 10,
                    "col": 1,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d0_r11_c1"
                },
                {
                    "number": "34",
                    "seatType": "VERTICAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 13,
                    "col": 1,
                    "deck": 0,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_true",
                    "id": "d0_r13_c2"
                }
            ],
            "maxRows": 15,
            "maxCols": 4,
            "deckType": "UPPER",
            "availableSeatCount": 12,
            "deckNumber": 0
        },
        {
            "seats": [
                {
                    "number": "21",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 8,
                    "col": 3,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d1_r9_c3"
                },
                {
                    "number": "19",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 8,
                    "col": 0,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d1_r9_c0"
                },
                {
                    "number": "20",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 8,
                    "col": 1,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d1_r9_c1"
                },
                {
                    "number": "15",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 6,
                    "col": 3,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_false",
                    "id": "d1_r7_c3"
                },
                {
                    "number": "13",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 6,
                    "col": 0,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_false",
                    "id": "d1_r7_c0"
                },
                {
                    "number": "14",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 6,
                    "col": 1,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_false",
                    "id": "d1_r7_c1"
                },
                {
                    "number": "9",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 4,
                    "col": 3,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d1_r5_c3"
                },
                {
                    "number": "7",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 4,
                    "col": 0,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d1_r5_c0"
                },
                {
                    "number": "8",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 4,
                    "col": 1,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d1_r5_c1"
                },
                {
                    "number": "3",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 2,
                    "col": 3,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d1_r3_c3"
                },
                {
                    "number": "1",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 2,
                    "col": 0,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d1_r3_c0"
                },
                {
                    "number": "2",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 2,
                    "col": 1,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d1_r3_c1"
                },
                {
                    "number": "D",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 0,
                    "col": 3,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_false",
                    "id": "d1_r1_c3"
                },
                {
                    "number": "A",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 0,
                    "col": 0,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_false",
                    "id": "d1_r1_c0"
                },
                {
                    "number": "B",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 0,
                    "col": 1,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_false",
                    "id": "d1_r1_c1"
                },
                {
                    "number": "33",
                    "seatType": "VERTICAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 13,
                    "col": 1,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_true",
                    "id": "d1_r13_c2"
                },
                {
                    "number": "31",
                    "seatType": "VERTICAL_SLEEPER",
                    "available": false,
                    "gender": "MALE",
                    "row": 12,
                    "col": 1,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_UNAVAILABLE_MALE_true",
                    "id": "d1_r12_c2"
                },
                {
                    "number": "27",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 10,
                    "col": 3,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d1_r11_c3"
                },
                {
                    "number": "26",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 10,
                    "col": 1,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d1_r11_c1"
                },
                {
                    "number": "25",
                    "seatType": "HORIZONTAL_SLEEPER",
                    "available": true,
                    "gender": "NA",
                    "row": 10,
                    "col": 0,
                    "deck": 1,
                    "singleBookable": true,
                    "fareId": 0,
                    "reservedForSocialDistancing": false,
                    "imageId": "SLEEPER_AVAILABLE_UNISEX_false",
                    "id": "d1_r11_c0"
                }
            ],
            "maxRows": 15,
            "maxCols": 4,
            "deckType": "LOWER",
            "availableSeatCount": 12,
            "deckNumber": 1
        }
    ],
      images: [
        {
          imageId: 'SLEEPER_UNAVAILABLE_MALE_false',
          unselectedUrl: 'https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seatmap/seat_sl_uav_mal.webp'
        },
        {
          imageId: 'SLEEPER_AVAILABLE_UNISEX_false',
          unselectedUrl: 'https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seatmap/seat_sl_avl_uni.webp'
        }
      ],
     
    },
    dropPoints:[
      { time: '05:50, 14 JUL', name: 'Thane', detail: 'bus will change at indore with 10 hour layover' },
      { time: '06:00, 14 JUL', name: 'Vikhroli', detail: 'bus will change at indore with 10 hour layover' },
      { time: '06:05, 14 JUL', name: 'Chembur', detail: 'bus will change at indore with 10 hour layover' },
      { time: '06:40, 14 JUL', name: 'Sion', detail: 'bus will change at indore with 10 hour layover' },
      { time: '07:05, 14 JUL', name: 'Vile Parle East', detail: 'bus will change at indore with 10 hour layover' }
    ],
    seatConfig: [
      {
        seat_price: 250,
        seat_map: [
          {
            seat_label: "1",
            layout: "g_____"
          },
          {
            seat_label: "2",
            layout: "gg__gg"
          },
          {
            seat_label: "3",
            layout: "gg__gg"
          },
          {
            seat_label: "4",
            layout: "gg__gg"
          },
          {
            seat_label: "5",
            layout: "gg__gg"
          },
          {
            seat_label: "6",
            layout: "gg__gg"
          },
          {
            seat_label: "7",
            layout: "gg__gg"
          },
          {
            seat_label: "8",
            layout: "gggggg"
          }
        ]
      }
    ]
  },
  {
    name: 'Ravina Travels (Regd)',
    type: 'A/C Sleeper (2+1)',
    departureTime: '16:30',
    departureDate: '12 JUL',
    duration: '32h 00m',
    arrivalTime: '00:30',
    arrivalDate: '14 JUL+1 day',
    rating: 2.0,
    reviews: 0,
    price: 3199,
    seatsLeft: 36,
    singleSeats: 12,
    showSeats:false,
    seats:{
      decks: [
        {
          seats: [
            { number: 'C', available: false, imageId: 'SLEEPER_UNAVAILABLE_MALE_false', id: 'd0_r1_c0' },
            { number: 'F', available: false, imageId: 'SLEEPER_UNAVAILABLE_MALE_false', id: 'd0_r1_c1' },
            { number: '6', available: true, imageId: 'SLEEPER_AVAILABLE_UNISEX_false', id: 'd0_r3_c0' },
            { number: '5', available: true, imageId: 'SLEEPER_AVAILABLE_UNISEX_false', id: 'd0_r3_c1' },
          ]
        },
        {
          seats: [
            { number: '21', available: true, imageId: 'SLEEPER_AVAILABLE_UNISEX_false', id: 'd1_r9_c3' },
            { number: '19', available: true, imageId: 'SLEEPER_AVAILABLE_UNISEX_false', id: 'd1_r9_c0' },
          ]
        }
      ],
      images: [
        {
          imageId: 'SLEEPER_UNAVAILABLE_MALE_false',
          unselectedUrl: 'https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seatmap/seat_sl_uav_mal.webp'
        },
        {
          imageId: 'SLEEPER_AVAILABLE_UNISEX_false',
          unselectedUrl: 'https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seatmap/seat_sl_avl_uni.webp'
        }
      ],
     
    },
    dropPoints:[
      { time: '05:50, 14 JUL', name: 'Thane', detail: 'bus will change at indore with 10 hour layover' },
      { time: '06:00, 14 JUL', name: 'Vikhroli', detail: 'bus will change at indore with 10 hour layover' },
      { time: '06:05, 14 JUL', name: 'Chembur', detail: 'bus will change at indore with 10 hour layover' },
      { time: '06:40, 14 JUL', name: 'Sion', detail: 'bus will change at indore with 10 hour layover' },
      { time: '07:05, 14 JUL', name: 'Vile Parle East', detail: 'bus will change at indore with 10 hour layover' }
    ],
    seatConfig: [
      {
        seat_price: 250,
        seat_map: [
          {
            seat_label: "1",
            layout: "g_____"
          },
          {
            seat_label: "2",
            layout: "gg__gg"
          },
          {
            seat_label: "3",
            layout: "gg__gg"
          },
          {
            seat_label: "4",
            layout: "gg__gg"
          },
          {
            seat_label: "5",
            layout: "gg__gg"
          },
          {
            seat_label: "6",
            layout: "gg__gg"
          },
          {
            seat_label: "7",
            layout: "gg__gg"
          },
          {
            seat_label: "8",
            layout: "gggggg"
          }
        ]
      }
    ]
  }
];


selectedSeats: any = [];

lowerDeckSeats(seats:any) {
  return seats.decks[0].seats;
}

upperDeckSeats(seats:any) {
  return seats.decks[1].seats;
}

getSeatImage(seat: any,seats:any): string {
  const image = seats.images.find((img:any) => img.imageId === seat.imageId);
  return image ? image.unselectedUrl : '';
}

selectSeats(seat: any,seats:any): void {
  if (!seat.available) return;
  const index = this.selectedSeats.indexOf(seat.id);
  if (index > -1) {
    this.selectedSeats.splice(index, 1);
  } else {
    this.selectedSeats.push(seat.id);
  }


  this.filterSelectedSeats(seats)
}


showSeats:boolean=false


selectedShowSeats:any=[]
filterSelectedSeats(seats:any) {
  const ids = this.selectedSeats;
  this.selectedShowSeats = [];

  for (let deck of seats.decks) {
    for (let seat of deck.seats) {
      if (ids.includes(seat.id)) {
        this.selectedShowSeats.push(seat.number);
      }
    }
  }
  console.log(this.selectedShowSeats)
}





public seatConfig: any = null;
public seatmap:any = [];
public seatChartConfig = {
  showRowsLabel: false,
  showRowWisePricing: false,
  newSeatNoForRow: false
};
public cart:any = {
  selectedSeats: [],
  seatstoStore: [],
  totalamount: 0,
  cartId: "",
  eventId: 0
};

title = "seat-chart-generator";

ngOnInit(): void {
  //Process a simple bus layout
  this.seatConfig = [
    {
      seat_price: 250,
      seat_map: [
        {
          seat_label: "1",
          layout: "g_____"
        },
        {
          seat_label: "2",
          layout: "gg__gg"
        },
        {
          seat_label: "3",
          layout: "gg__gg"
        },
        {
          seat_label: "4",
          layout: "gg__gg"
        },
        {
          seat_label: "5",
          layout: "gg__gg"
        },
        {
          seat_label: "6",
          layout: "gg__gg"
        },
        {
          seat_label: "7",
          layout: "gg__gg"
        },
        {
          seat_label: "8",
          layout: "gggggg"
        }
      ]
    }
  ];
  
  
  // this.processSeatChart(this.seatConfig,img);
  // this.blockSeats("7_1,7_2");
}
onClickSelect(seatConfig:any,seats:any){
  let img:any=[
    {
      imageId: 'SLEEPER_UNAVAILABLE_MALE_false',
      unselectedUrl: 'https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seatmap/seat_sl_uav_mal.webp'
    },
    {
      imageId: 'SLEEPER_AVAILABLE_UNISEX_false',
      unselectedUrl: 'https://jsak.mmtcdn.com/bus_cdn_rnw/static/images/Bus/seatmap/seat_sl_avl_uni.webp'
    }
  ];
  this.processSeatChart(seatConfig,seats);
  this.blockSeats("7_1,7_2");
}
// public processSeatChart(map_data: any[]) {
//   if (map_data.length > 0) {
//     var seatNoCounter = 1;
//     for (let __counter = 0; __counter < map_data.length; __counter++) {
//       var row_label = "";
//       var item_map = map_data[__counter].seat_map;

//       //Get the label name and price
//       row_label = "Row " + item_map[0].seat_label + " - ";
//       if (item_map[item_map.length - 1].seat_label != " ") {
//         row_label += item_map[item_map.length - 1].seat_label;
//       } else {
//         row_label += item_map[item_map.length - 2].seat_label;
//       }
//       row_label += " : Rs. " + map_data[__counter].seat_price;

//       item_map.forEach((map_element:any) => {
//         var mapObj:any = {
//           seatRowLabel: map_element.seat_label,
//           seats: [],
//           seatPricingInformation: row_label
//         };
//         row_label = "";
//         var seatValArr = map_element.layout.split("");
//         if (this.seatChartConfig.newSeatNoForRow) {
//           seatNoCounter = 1; //Reset the seat label counter for new row
//         }
//         var totalItemCounter = 1;
//         seatValArr.forEach((item:any) => {
//           let seatObj:any = {
//             key: map_element.seat_label + "_" + totalItemCounter,
//             price: map_data[__counter]["seat_price"],
//             status: "available"
//           };

//           if (item != "_") {
//             seatObj["seatLabel"] =
//               map_element.seat_label + " " + seatNoCounter;
//             if (seatNoCounter < 10) {
//               seatObj["seatNo"] = "0" + seatNoCounter;
//             } else {
//               seatObj["seatNo"] = "" + seatNoCounter;
//             }

//             seatNoCounter++;
//           } else {
//             seatObj["seatLabel"] = "";
//           }
//           totalItemCounter++;
//           mapObj["seats"].push(seatObj);
//         });
//         console.log(" \n\n\n Seat Objects ", mapObj);
//         this.seatmap.push(mapObj);
//       });
//     }
//   }
// }

public processSeatChart(seatConfig: any[], seatData: any[]) {
//   this.seatmap = [];

//   if (seatConfig.length > 0) {
//     let seatNoCounter = 1;

//     for (let section = 0; section < seatConfig.length; section++) {
//       const { seat_map, seat_price } = seatConfig[section];
// // console.log(seatConfig[section])
//       for (let mapRow of seat_map) {
//         const seatRowLabel = mapRow.seat_label;
//         const seatLayoutArr = mapRow.layout.split('');
//         const mapObj: any = {
//           seatRowLabel: seatRowLabel,
//           seats: [],
//           seatPricingInformation: `Row ${seatRowLabel} : Rs. ${seat_price}`,
//            };

//         if (this.seatChartConfig?.newSeatNoForRow) {
//           seatNoCounter = 1;
//         }

//         let seatIndexInRow = 1;

//         for (let layoutChar of seatLayoutArr) {
//           const seatKey = seatRowLabel + "_" + seatIndexInRow;
//           const seatNumber = seatNoCounter < 10 ? "0" + seatNoCounter : "" + seatNoCounter;
//           let seatLabel = "";
//           let foundSeatMeta: any = null;

//           if (layoutChar !== "_") {
//             seatLabel = seatRowLabel + " " + seatNoCounter;

//             // 🔍 Find metadata from actual seatData by seat number
//             for (let block of seatData) {
//               console.log(block)
//               const match = block.seats.find(
//                (s:any) => s.number === seatNumber
//               );
//               if (match) {
//                 foundSeatMeta = match;
//                 break;
//               }
//             }

//             seatNoCounter++;
//           }

//           const seatObj: any = {
//             key: seatKey,
//             seatLabel,
//             seatNo: layoutChar !== "_" ? seatNumber : "",
//             price: seat_price,
//             status: foundSeatMeta?.available ? "available" : "unavailable",
//             gender: foundSeatMeta?.gender || "NA",
//             imageId: foundSeatMeta?.imageId || "",
//             id: foundSeatMeta?.id || null,
//             seatType: foundSeatMeta?.seatType || null,
//             deck: foundSeatMeta?.deck || 0,
//           };

//           mapObj.seats.push(seatObj);
//           seatIndexInRow++;
//         }
//         console.log(" \n\n\n Seat Objects ", mapObj);
//         this.seatmap.push(mapObj);
//       }
//     }
//   }


  this.seatmap = [];

  if (seatConfig.length === 0 || !seatData || seatData.length === 0) return;

  let seatNoCounter = 1;

  for (let section = 0; section < seatConfig.length; section++) {
    const { seat_map, seat_price } = seatConfig[section];

    for (let mapRow of seat_map) {
      const seatLayoutArr = mapRow.layout.split('');
      const rowSeats = [];

      let rowLabelFromData: string | null = null;

      // 🧠 Try to get a row number from seatData that matches this row by index
      for (let deckBlock of seatData) {
        for (let seat of deckBlock.seats) {
          if (seat.row === mapRow.seat_label) {
            rowLabelFromData = "Row " + seat.row;
            break;
          }
        }
        if (rowLabelFromData) break;
      }

      const seatRowLabel = rowLabelFromData || "Row " + mapRow.seat_label;

      const mapObj: any = {
        seatRowLabel,
        seats: [],
        seatPricingInformation: `${seatRowLabel} : Rs. ${seat_price}`,
      };

      if (this.seatChartConfig?.newSeatNoForRow) {
        seatNoCounter = 1;
      }

      let seatIndexInRow = 1;

      for (let layoutChar of seatLayoutArr) {
        const seatKey = seatRowLabel + "_" + seatIndexInRow;
        const seatNumber = seatNoCounter < 10 ? "0" + seatNoCounter : "" + seatNoCounter;
        let seatLabel = "";
        let foundSeatMeta: any = null;

        if (layoutChar !== "_") {
          seatLabel = seatRowLabel + " " + seatNoCounter;

          // 🔍 Match seat metadata by number
          for (let block of seatData) {
            foundSeatMeta = block.seats.find((s:any) =>
              s.number === seatNumber || s.number === seatNoCounter.toString()
            );
            if (foundSeatMeta) break;
          }

          seatNoCounter++;
        }

        const seatObj: any = {
          key: seatKey,
          seatLabel: seatLabel,
          seatNo: layoutChar !== "_" ? seatNumber : "",
          price: seat_price,
          status: foundSeatMeta?.available ? "available" : "unavailable",
          gender: foundSeatMeta?.gender || "NA",
          imageId: foundSeatMeta?.imageId || "",
          id: foundSeatMeta?.id || null,
          seatType: foundSeatMeta?.seatType || null,
          deck: foundSeatMeta?.deck || 0,
        };

        mapObj.seats.push(seatObj);
        seatIndexInRow++;
      }

      this.seatmap.push(mapObj);
    }
  }




}


private getImageForSeat(seat: any, images: any[]): string {
  const imageObj = images.find(img => img.imageId === seat.imageId);
  return imageObj ? imageObj.unselectedUrl : '';
}
public selectSeat(seatObject: any) {
  console.log("Seat to block: ", seatObject);
  if (seatObject.status == "available") {
    seatObject.status = "booked";
    this.cart.selectedSeats.push(seatObject.seatLabel);
    this.cart.seatstoStore.push(seatObject.key);
    this.cart.totalamount += seatObject.price;
  } else if ((seatObject.status = "booked")) {
    seatObject.status = "available";
    var seatIndex = this.cart.selectedSeats.indexOf(seatObject.seatLabel);
    if (seatIndex > -1) {
      this.cart.selectedSeats.splice(seatIndex, 1);
      this.cart.seatstoStore.splice(seatIndex, 1);
      this.cart.totalamount -= seatObject.price;
    }
  }
}

public blockSeats(seatsToBlock: string) {
  if (seatsToBlock != "") {
    var seatsToBlockArr = seatsToBlock.split(",");
    for (let index = 0; index < seatsToBlockArr.length; index++) {
      var seat = seatsToBlockArr[index] + "";
      var seatSplitArr = seat.split("_");
      console.log("Split seat: ", seatSplitArr);
      for (let index2 = 0; index2 < this.seatmap.length; index2++) {
        const element = this.seatmap[index2];
        if (element.seatRowLabel == seatSplitArr[0]) {
          var seatObj = element.seats[parseInt(seatSplitArr[1]) - 1];
          if (seatObj) {
            console.log("\n\n\nFount Seat to block: ", seatObj);
            seatObj["status"] = "unavailable";
            this.seatmap[index2]["seats"][
              parseInt(seatSplitArr[1]) - 1
            ] = seatObj;
            console.log("\n\n\nSeat Obj", seatObj);
            console.log(
              this.seatmap[index2]["seats"][parseInt(seatSplitArr[1]) - 1]
            );
            break;
          }
        }
      }
    }
  }
}


buss:any=[
  // {
  //   "id": "BUS123",
  //   "operatorName": "Rajdhani Travels",
  //   "busType": "Volvo AC Sleeper",
  //   "source": "Mumbai",
  //   "destination": "Pune",
  //   "route": "Mumbai-Pune Expressway",
  //   "aC": true,
  //   "sleeper": true,
  //   "seater": false,
  //   "departureTime": "2025-06-25T08:00:00",
  //   "arrivalTime": "2025-06-25T12:30:00",
  //   "duration": "4h 30m",
  //   "availableSeats": 12,
  //   "bookable": true,
  //   "fare": [
  //     {
  //       "baseFare": 700.0,
  //       "gst": 35.0,
  //       "serviceTax": 10.0,
  //       "totalFare": 800.0,
  //       "levyFare": 5.0,
  //       "markupFareAbsolute": 15.0,
  //       "markupFarePercentage": 2.5,
  //       "opFare": 720.0,
  //       "opGroupFare": 740.0,
  //       "operatorServiceChargeAbsolute": 10.0,
  //       "operatorServiceChargePercentage": 1.0,
  //       "tollFee": 20.0,
  //       "srtFee": 5.0,
  //       "childFare": 400.0,
  //       "bankTrexAmt": 8.0
  //     }
  //   ],
  //   "boardingPoint": [
  //     {
  //       "bpId": "BP001",
  //       "location": "Andheri East",
  //       "time": "2025-06-25T07:30:00",
  //       "address": "Near Bus Stand, Andheri East, Mumbai",
  //       "contactNumber": "+91-9876543210",
  //       "prime": "Yes"
  //     },
  //     {
  //       "bpId": "BP002",
  //       "location": "Chembur",
  //       "time": "2025-06-25T07:45:00",
  //       "address": "Opp. Railway Station, Chembur",
  //       "contactNumber": "+91-9876501234",
  //       "prime": "No"
  //     }
  //   ],
  //   "droppingPoint": [{
  //     "dpId": "DP001",
  //     "location": "Swargate",
  //     "time": "2025-06-25T12:30:00",
  //     "address": "Swargate Bus Depot, Pune",
  //     "contactNumber": "+91-9123456780",
  //     "prime": "Yes"
  //   }]
  // }
  
 ]
searchData(){
 this.buss=[
  {
    "id": "BUS123",
    "operatorName": "Rajdhani Travels",
    "busType": "Volvo AC Sleeper",
    "source": "Mumbai",
    "destination": "Pune",
    "route": "Mumbai-Pune Expressway",
    "aC": true,
    "sleeper": true,
    "seater": false,
    "departureTime": "2025-06-25T08:00:00",
    "arrivalTime": "2025-06-25T12:30:00",
    "duration": "4h 30m",
    "availableSeats": 12,
    "bookable": true,
    "fare": [
      {
        "baseFare": 700.0,
        "gst": 35.0,
        "serviceTax": 10.0,
        "totalFare": 800.0,
        "levyFare": 5.0,
        "markupFareAbsolute": 15.0,
        "markupFarePercentage": 2.5,
        "opFare": 720.0,
        "opGroupFare": 740.0,
        "operatorServiceChargeAbsolute": 10.0,
        "operatorServiceChargePercentage": 1.0,
        "tollFee": 20.0,
        "srtFee": 5.0,
        "childFare": 400.0,
        "bankTrexAmt": 8.0
      }
    ],
    "boardingPoint": [
      {
        "bpId": "BP001",
        "location": "Andheri East",
        "time": "2025-06-25T07:30:00",
        "address": "Near Bus Stand, Andheri East, Mumbai",
        "contactNumber": "+91-9876543210",
        "prime": "Yes"
      },
      {
        "bpId": "BP002",
        "location": "Chembur",
        "time": "2025-06-25T07:45:00",
        "address": "Opp. Railway Station, Chembur",
        "contactNumber": "+91-9876501234",
        "prime": "No"
      }
    ],
    "droppingPoint":[{
      "dpId": "DP001",
      "location": "Swargate",
      "time": "2025-06-25T12:30:00",
      "address": "Swargate Bus Depot, Pune",
      "contactNumber": "+91-9123456780",
      "prime": "Yes"
    }]
  }
  
 ]
}
selectedBoarding: string = '';
selectedDrop: string = '';
getDayDifference(departure: string, arrival: string): string {
  const depDate = new Date(departure);
  const arrDate = new Date(arrival);

  // Set time to 00:00 to compare calendar days only
  const dep = new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate());
  const arr = new Date(arrDate.getFullYear(), arrDate.getMonth(), arrDate.getDate());

  const msInDay = 1000 * 60 * 60 * 24;
  const diff = Math.floor((arr.getTime() - dep.getTime()) / msInDay);

  return diff > 0 ? `+${diff} day${diff > 1 ? 's' : ''}` : '';
}
busDetails:any
lowerBerths:any
upperBerths:any
seats: Seat[] = [/* your seat objects here */];
seatRows:any
onClickSBuseats(bus:any){
  for(let seats of this.buss){
    seats.showSeats=false
  }
bus.showSeats=!bus.showSeats
let request:any={
  "inventoryId":bus?.id,
  "doj":bus?.doj
}
this.BusService.searchSeats(request)
.subscribe({
  next: (res) => {

    let data: any
    data = res
    if(data){
      console.log(data)
      this.busDetails=data
     
this.seats=this.busDetails.seats
this.seatRows = this.groupSeatsByColumn(this.seats);

    }




 

  }, error: (err) => {


   
  }
}
)
}


  getSeatsByRow(row: number) {
    return this.seats
      .filter((seat:any) => seat.row === row)
      .sort((a:any, b:any) => a.column - b.column);
  }

  get lowerBerthSeats() {
    return this.getSeatsByRow(0);
  }

  get upperBerthSeats() {
    return this.getSeatsByRow(2);
  }

  groupSeatsByColumn(seats: any[]): { [column: number]: any[] } {
    const grouped: { [column: number]: any[] } = {};
    seats.forEach(seat => {
      if (!grouped[seat.column]) {
        grouped[seat.column] = [];
      }
      grouped[seat.column].push(seat);
    });

    // Optional: Sort rows inside each column
    for (const key in grouped) {
      grouped[key].sort((a, b) => a.row - b.row);
    }

    return grouped;
  }

  columnSorter = (a: { key: string }, b: { key: string }) => +a.key - +b.key;


  groupSeatsByRow(seats: any[]): { [row: number]: any[] } {
    const grouped: { [row: number]: any[] } = {};
    seats.forEach(seat => {
      if (!grouped[seat.row]) {
        grouped[seat.row] = [];
      }
      grouped[seat.row].push(seat);
    });
    return grouped;
  }

  seatRowSorter = (a: { key: string }, b: { key: string }) => {
    return +a.key - +b.key;
  };

  asArray(value: unknown): any[] {
    return value as any[];
  }
  
}
